import { render, staticRenderFns } from "./DefectView.vue?vue&type=template&id=35ccdb5b&scoped=true"
import script from "./DefectView.vue?vue&type=script&lang=js"
export * from "./DefectView.vue?vue&type=script&lang=js"
import style0 from "./DefectView.vue?vue&type=style&index=0&id=35ccdb5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ccdb5b",
  null
  
)

export default component.exports